import {ParallaxProvider, Parallax } from "react-scroll-parallax"
import  "./experiences.scss"
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Experiences({openModal}) {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);
  return(
    <>
      <div className="experiences_wrapper" id="experiences">
        <div className="container">
          <div className="title_wrapper" data-aos-offset="500" data-aos-delay="100" data-aos="fade-up">
            <h2>Experiences</h2>
            <h3>Unforgettable Journeys Tailored to You</h3>
            <p>Deus Ex machina’s packages all include snorkeling, complimentary snacks and sodas.</p>
          </div>
          <div className="inner_title white" data-aos-offset="500" data-aos-delay="100" data-aos="fade-up">
            <h2>Entry Charters</h2>
          </div>
          <div className="experiences_card_wrap">
            <div className="experiences_card white_card" data-aos-offset="500" data-aos-delay="100" data-aos="fade-right">
              <span>Open seas</span>
              <h4>$4500</h4>
              <p>Our simplest charter. Do it your way! There are no inclusions on this charter in regard to food and beverage, however you are welcome to bring your own.
              (No red wine)</p>
            </div>
            <div className="experiences_card white_card" data-aos-offset="500" data-aos-delay="100" data-aos="fade-left">
              <span>Rum Run</span>
              <h4>$5000</h4>
              <p>Rum & Rum punch & snacks. Basic and beautiful.</p>
            </div>
          </div>
        </div>
        <ParallaxProvider>
        <div className="experiences_bg_wrap">
          <Parallax speed={-30}>
            <div className="paralex_bg"/>
          </Parallax>
          <div className="container">
            <div className="inner_title" data-aos-offset="500" data-aos-delay="100" data-aos="fade-up">
              <h2>Entry Charters</h2>
              <p>The following charters also include mixes and a selection of beer & prosecco</p>
            </div>
            <div className="experiences_card_wrap bg_wrap">
              <div className="experiences_card" data-aos-offset="500" data-aos-delay="100" data-aos="fade-right">
                <span>Tranquil tides</span>
                <h4>$6000</h4>
                <p>Basic Bar rail / beverages Such as rum punch, Appleton 62, Smirnoff. Two menu items.</p>
              </div>
              <div className="experiences_card" data-aos-offset="500" data-aos-delay="100" data-aos="fade-left">
                <span>Montego Bay Luxe</span>
                <h4>$7500</h4>
                <p>Premium Bar rail / beverages Such as Daiquiris, signature cocktails, Appleton Signature, Absolute, Teramona. Four menu items.</p>
              </div>
              <div className="experiences_card" data-aos-offset="500" data-aos-delay="100" data-aos="fade-up">
                <span>The deus ex machina Signature</span>
                <h4>$9000</h4>
                <p>Premium Bar rail / beverages Such as daiquiris, signature cocktails, Appleton 12 year, Grey Goose, Casamigos, johnny walker black label, Malfy gin, Bollinger champagne. Six menu items</p>
              </div>
            </div>
            <div className="button_area" data-aos-offset="500" data-aos-delay="100" data-aos="fade-up">
              <p>If there are any further customization's or requests please feel free to reach out to us.</p>
              <button className="simple_btn" onClick={openModal}>
                Contact
              </button>
            </div>
          </div>
        </div>
        </ParallaxProvider>
      </div>
    </>
  )
}